import { BatchCosignItem } from "../types";

export function adaptBatchItem(items: BatchCosignItem[]) {
  return items.map((item) => ({
    document_id: item.documentId,
    document_type: item.documentType,
    patient_id: item.patientId,
  }));
}
